"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FullPriceModal = require("./FullPriceModal");
Object.keys(_FullPriceModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FullPriceModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FullPriceModal[key];
    }
  });
});